<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xii"></a>
<div class="img_container1">
<img alt="images" src="images/f0xii-01.jpg"/>
</div>
<div class="img_container1">
<img alt="images" src="images/f0xii-02.jpg"/>
<p class="mapc">The Eastern and Western Mediterranean in the Thirteenth Century.</p>
</div>
<a id="page_xiii"></a>
<div class="img_container1">
<img alt="images" src="images/fxiii-01.jpg"/>
</div>
<div class="img_container1">
<img alt="images" src="images/fxiii-02.jpg"/>
<p class="mapc">North-Central France and England in the Thirteenth Century.</p>
</div>
<a id="page_xiv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?1f90487c